import {headingSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const SimilarHotelPricingWrapDiv = styled.div(
  props => `

  display:flex;
  flex-direction:column;
  padding-top:${props.theme.spacing.large};
  // padding-bottom:${props.theme.spacing.small};

`,
);

export const HotelOldPrice = styled.div(
  props => `

  color: ${props.theme.colors.downriver.medium};
  text-decoration:line-through;
  padding-bottom:${props.theme.spacing.small};

`,
);

export const HotelFinalPrice = styled.div`
  ${headingSizes.MediumW1}
  padding-bottom:${props => props.theme.spacing.small};
`;

export const HotelPerNight = styled.div(
  props => `

  color: ${props.theme.colors.downriver.medium};


`,
);
